import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Col, Row, Card, Form } from '@themesberg/react-bootstrap'
import { Context } from '../ByDoneTicket'
import { getDoneTicketStatisticSummary } from '../../../../controller/api/statistic/printTicket';
import { useCookies } from 'react-cookie';

const _Summary = () => {

  const { state } = useContext(Context);

  const [cookies] = useCookies(['lottmekong'])

  const [data, setData] = useState({
    countBuyTicket: 0,
    countCashback: 0,
    totalBuyTicket: '0',
    totalCashback: '0',
  })

  const getSummaryFunc = useCallback(async () => {
    let phone = state.filter.phone

    const response = await getDoneTicketStatisticSummary(cookies.lottmekong, {
      from: state.filter.from,
      to: state.filter.to,
      phone: phone,
      gameId: state.filter.gameId,
      level: state.filter.group == 'A' ? '9,10' : state.filter.group == 'B' ? '0,1,2,3,4,5,6,7,8' : '0,1,2,3,4,5,6,7,8,9,10',
    })

    if (response) {
      const res = {
        count: response.count,
        total: response.total
      }
      setData(res || {})
    }
  }, [cookies.lottmekong, state.filter.from, state.filter.to, state.filter.phone, state.filter.gameId, state.filter.group])

  useEffect(() => {
    getSummaryFunc()
  }, [getSummaryFunc, state.filterPressCount])

  return (
    <>
      <Card border="light" className="shadow-sm">
        <Card.Body>
          <Col>
            {state.loading ? <h2 className='text-center'>Đang tải dữ liệu</h2> :
              <Row>
                <Col>
                  <Row md={12} className='text-center align-self-center'>
                    <Form.Label>Tổng số vé</Form.Label>
                  </Row>
                  <Row md={12} className='text-center align-self-center'>
                    <Form.Label>{data.count}</Form.Label>
                  </Row>
                </Col>
                <Col>
                  <Row md={12} className='text-center align-self-center'>
                    <Form.Label>Tổng tiền</Form.Label>
                  </Row>
                  <Row md={12} className='text-center align-self-center'>
                    <Form.Label>{new Intl.NumberFormat('vn-VI', {}).format(data.total) || ""}</Form.Label>
                  </Row>
                </Col>
              </Row>
            }
          </Col>
        </Card.Body>
      </Card>
    </>
  );
};

export default React.memo(_Summary)